import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { TerritoriesService } from './TerritoriesService.service';
import { TerritoriesLayerControlService } from './TerritoriesLayerControl.service';

@Injectable({
  providedIn: 'root'
})
export class PanelTerritoriesService {
  // locationsGeoJson: { [key: string]: any } = {};

  private isLoading$: Subject<boolean> = new Subject();
  private areTerrioryPanelLayersVisible: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(private territoriesService: TerritoriesService, private territoriesLayerService: TerritoriesLayerControlService) {
  }

  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }
  
  setAreTerritoryPanelLayersVisible(resp: boolean) {
    this.areTerrioryPanelLayersVisible.next(resp);
  }

  getAreTerritoryPanelLayersVisible() {
    return this.areTerrioryPanelLayersVisible.asObservable();
  }

  initializeLayers(){
    this.territoriesLayerService.initializeTerritorySourceAndLayers();
  }

  loadMorePolygonGeoJson(geoJson: any){
    this.territoriesLayerService.loadMorePolygonGeoJson('all', geoJson);
  }

  loadPolygonGeoJson(geoJson: any){
    this.territoriesLayerService.loadPolygonGeoJson('all', geoJson);
  }

   resetLocationGeoJson(){
    this.territoriesLayerService.resetLocationGeoJson('all');
   }

  loadMoreLocationGeoJson(geoJson: any){
    this.territoriesLayerService.loadMoreLocationGeoJson('all', geoJson);
  }

  addActiveTerritoryPolygonFilter(territoryId: string) {
    this.territoriesLayerService.addActiveTerritoryPolygonFilter(territoryId);
  }

  removeActiveTerritoryPolygonFilter(territoryId: string) {
    this.territoriesLayerService.removeActiveTerritoryPolygonFilter(territoryId);
  }

  addActiveTerritoryLocationFilter(territoryIdentifier: string) {
    this.territoriesLayerService.addActiveTerritoryLocationFilter(territoryIdentifier);
  }

  removeActiveTerritoryLocationFilter(territoryIdentifier: string) {
    this.territoriesLayerService.removeActiveTerritoryLocationFilter(territoryIdentifier);
  }

  removeFilters(){
    this.territoriesLayerService.removeFilters();
  }

  assignColor(identifier: string){
    return this.territoriesLayerService.assignColor(identifier);
  }

  // toggleTerritoryLayers(isVisible: boolean){
  //   this.territoriesLayerService.toggleTerritoryLayers(isVisible, 'panel');
  // }

  destroyLayers(){
    this.territoriesLayerService.destroySourceAndLayers();
  }

  loadCentroidGeoJson(geoJson: any){
    this.territoriesLayerService.loadCentroidGeoJson('all', geoJson);
  }

  resetCentroidGeoJson(){
    this.territoriesLayerService.resetCentroidsGeoJson('all');
  }

  closeDetailPopUp(){
    this.territoriesLayerService.closeDetailPopUp();
  }
}
